export default __webpack_public_path__ + "static/media/order_rate.adbb6d50.png";